import React, { Component } from 'react';
import axios from 'axios';
import global from '../global';
import { config } from '../../Constants';
import download from 'downloadjs';
import { Layout } from '../Layout';
import Spinner from '../Spinner';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NotificationContainer, NotificationManager } from 'react-notifications';

export class BulkXMLGeneration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading : false,
            file: '',
            filesToBeSent: '',
            fileName: '',
        };
    }
    handleCancel(e) {
        e.preventDefault();
        var url = config.url.Web_URL;
        window.location.href = url + `/${localStorage.getItem('remitterCode')}/Dashboard`;
    }
    handelFileChange = event => {
        // Update the state 
        let file = event.target.files[0];
        var type = file.name.substring(file.name.lastIndexOf('.') + 1);
        if (type == "xlsx" || type == "xls") {
            this.setState({ filesToBeSent: event.target.files[0] });
        }
        else {
            this.NotificationAlert('error', global.Message.FormatRequiredMessage);
        }
    };

    NotificationAlert = (type, message) => {
        switch (type) {
            case 'success':
                NotificationManager.success(message);
                break;

            case 'error':
                NotificationManager.error(message, () => {
                    alert('callback');
                });
                break;
            default:
                break;
        }
    };

    handleUploadClick = (event) => {
        this.state.loading = true;
        event.preventDefault();
        //var self = this;
        if (this.state.filesToBeSent != undefined) {
            var filesArray = this.state.filesToBeSent;
            let form = new FormData();
            form.append("File", filesArray);
            form.append("fileName", filesArray.name);
            console.log(global.BulkUpload.UploadFileAPI);
            axios.post(global.BulkUpload.UploadFileAPI, form,
                { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` } })
                .then(response => {
                    if (response.status) {
                        this.setState({ loading: false });;
                        this.NotificationAlert('success', global.Message.SuccessMessage);
                        this.setState({file: '', filesToBeSent: '', fileName: '' });

                    } else {
                        this.setState({ loading: false });;
                        this.notificationalert('error', response.Message);
                    }
                })
                .catch(error => {
                    this.setState({ loading: false });
                    console.log(error);
                });

        }
        else {
            this.setState({ loading: false });;
            alert("Please select files first");
        }
    }

    render() {
        if (this.state.loading) return <Spinner />;
        let content = Layout.RenderNavMenu();
        return (
            <div>
                {content}
                <div className="Nexdigm">
                    <ol className="breadcrumb btn-Nexdigm">
                        <li><Link to={"/" + this.state.url + "/Dashboard"} className="text-white"><FontAwesomeIcon icon="home" /> Home</Link></li>
                        <li><Link to={"/" + this.state.url + "/Bulk-Upload"} className="text-white">XML Generation</Link></li>

                    </ol>
                </div>
                <div className="content-page">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="header-title">Bulk XML Generation</h4>
                            <br/>
                            <div>
                                <form>
                                    <div className="row">
                                        <div className = "m-l-10">
                                            <input type="file" id="myFile" name="filename" onChange={this.handelFileChange} />
                                            </div>
                                         <div>
                                        <button className="btn btn-dark" onClick={this.handleCancel}>Cancel</button>
                                            <button className="btn btn-success m-l-10" onClick={this.handleUploadClick}> Upload </button>
                                        </div>
                                        </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <NotificationContainer enterTimeout={800} leaveTimeout={1000} />
            </div>
        );
    }
}